import { useState, useEffect } from 'react'

import { Grid, Typography, Tab, Tabs, TextField, Button} from "@mui/material"
import { withStyles } from '@material-ui/core/styles'

import styles from './campaignStyle'

import { httpRequest } from '../../../../ui-utils/api'
import { backendHosts, apiUrl } from '../../../../ui-utils/apiConfig'

import SocialAd from './SocialAd'
import BullForce from './BullForce'
import SignUp from './SignUp'

const Campaign = ({classes}) => {
    const [tabId, setTabId] = useState(0)

    const [campaignList, setCampaignList] = useState([])
    const [originalCampaignList, setOriginalCampaignList] = useState([])

    const [campaignInfo, setCampaignInfo] = useState([])
    const [originalCampaignInfo, setOriginalCampaignInfo] = useState([])

    const [visitorsList, setVisitorsList] = useState([])
    const [originalVisitorsList, setOriginalVisitorsList] = useState([])

    const [visitorsInfo, setVisitorsInfo] = useState([])
    const [originalVisitorsInfo, setOriginalVisitorsInfo] = useState([])

    const [searchCode, setSearchCode] = useState("")
    // Refactor data fetching into multiple useEffect hook - Srini - 24/12/24
    useEffect(() => {
        (async () => {
            try {
                const campaignListResult = await httpRequest({
                    endPoint: `${backendHosts.ADMIN}${apiUrl.campaignList}`,
                    method: "get",
                    instance: "instanceOne",
                })
                setCampaignList(campaignListResult)
                setOriginalCampaignList(campaignListResult)
            } catch (err) {
                console.log("Error in fetching Campaign List", err)
            }
        })()
    }, [])
    
    useEffect(() => {
        (async () => {
            try {
                const campaignInfoResult = await httpRequest({
                    endPoint: `${backendHosts.ADMIN}${apiUrl.campaignInfo}`,
                    method: "get",
                    instance: "instanceOne",
                })
                const sortedInfo = campaignInfoResult.sort(
                    (a, b) => new Date(b.date) - new Date(a.date)
                )
                setCampaignInfo(sortedInfo)
                setOriginalCampaignInfo(sortedInfo)
            } catch (err) {
                console.log("Error in fetching Campaign Info", err)
            }
        })()
    }, [])
    
    useEffect(() => {
        (async () => {
            try {
                const visitorsListResult = await httpRequest({
                    endPoint: `${backendHosts.ADMIN}${apiUrl.pageVistors}`,
                    method: "get",
                    instance: "instanceOne",
                })
                setVisitorsList(visitorsListResult)
                setOriginalVisitorsList(visitorsListResult)
            } catch (err) {
                console.log("Error in fetching Visitors List", err)
            }
        })()
    }, [])
    
    useEffect(() => {
        (async () => {
            try {
                const visitorsInfoResult = await httpRequest({
                    endPoint: `${backendHosts.ADMIN}${apiUrl.vistorsInfo}`,
                    method: "get",
                    instance: "instanceOne",
                })
                const sortedInfo = visitorsInfoResult.sort(
                    (a, b) => new Date(b.date) - new Date(a.date)
                )
                setVisitorsInfo(sortedInfo)
                setOriginalVisitorsInfo(sortedInfo)
            } catch (err) {
                console.log("Error in fetching Visitors Info", err)
            }
        })()
    }, [])
    
    const handleTabChange = (number) => {
        setTabId(number)
    }

    const handleSearchChange = (e) => {
        const searchValue = e.target.value.toUpperCase()
        setSearchCode(searchValue)

        if (searchValue === "") {
            setCampaignList(originalCampaignList)
            setCampaignInfo(originalCampaignInfo)
            setVisitorsList(originalVisitorsList)
            setVisitorsInfo(originalVisitorsInfo)
        }
    }

    const filterCampaignsByCode = () => {
        const filterCampaigns = visitorsList.filter((record) => {
            const campaignCode = record.page_name?.split(" ")[1]
            return campaignCode === searchCode
        })

        const filteredDates = filterCampaigns.map((campaign) => campaign.date_time?.split("T")[0])
        
        // - filter along search code Srini - 05-02-25
        setCampaignList(
            originalCampaignList.filter((info) => {
                const infoDate = info.date_time?.split("T")[0]
                const campaignCode = info.campaign_link?.split(" ")[1]
                return filteredDates.includes(infoDate) && campaignCode === searchCode
            })
        )

        setCampaignInfo(originalCampaignInfo.filter((info) => filteredDates.includes(info.date)))
        setVisitorsInfo(originalVisitorsInfo.filter((info) => filteredDates.includes(info.date)))
    }

    const smalltextFieldStyles = {
        marginRight:'10px !important',
        '& .MuiInputBase-root': {
                            backgroundColor: '#131E2E !important', 
                            color: 'white !important',
                            fontFamily: 'cardiuma-regular',
                            fontSize:'15px'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '131E2E !important',
                        },
                        '& .MuiInputLabel-root': {
                            color: 'white !important',
                            fontFamily: 'cardiuma-regular', 
                            fontSize: '14px',
                        },
                        '& .MuiInputBase-input': {
                            color: 'white !important',
                        },
                        "@media only screen and (max-width: 1620px)": {
                            width: '150px !important'
                        },
                        "@media only screen and (max-width: 1420px)": {
                            width: '130px !important'
                        },
                        "@media only screen and (max-width: 1350px)": {
                            width: '120px !important'
                        },
    }

    return (
        <Grid
            sx={{ margin: "7% 0 0 2%" }}
        >
            <Grid>
                <Typography
                    className={classes.campaignText}
                >Campaign</Typography>
            </Grid>

            <Grid sx={{marginTop: '30px'}}>
                <TextField
                    label="Ref Code"
                    variant="outlined"
                    value={searchCode}
                    onChange={handleSearchChange}
                    size='small'
                    sx={{ ...smalltextFieldStyles }}
                />
                <Button
                    onClick={filterCampaignsByCode}
                    style={{
                        width: '100px',
                        height: '35px',
                        color: '#fff',
                        backgroundColor: '#F44748',
                        fontFamily: 'cardiuma-regular',
                        fontSize: '11px',
                        fontStyle: 'normal',
                        marginTop:'2px'
                    }}
                >
                    Submit
                </Button>

            </Grid>

            <Grid>
                <Tabs
                    value={tabId || 0}
                    onChange={handleTabChange}
                    variant='standard'
                    classes={{
                        indicator: classes.indicator
                    }}
                    indicatorColor='primary'
                    sx={{ margin: '2% 0 0 0', }}

                >
                    <Tab
                        value={0} onClick={() => handleTabChange(0)} className={classes.pending_heading}
                        label={`Campaign - (${visitorsList.filter(ele => ele.page_name.split(" ")[0] === 'ad_campaign').length})`}
                        sx={{
                            borderBottom: tabId !== 0 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            fontFamily: tabId !== 0 ? 'cardiuma-regular' : 'cardiuma-SemiBold',
                        }}
                    />

                    <Tab
                        value={1} onClick={() => handleTabChange(1)} className={classes.pending_heading}
                        label={`BullForce - (${visitorsList.filter(ele => ele.page_name === 'bullforce.co').length})`}
                        sx={{
                            borderBottom: tabId !== 1 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            fontFamily: tabId !== 1 ? 'cardiuma-regular' : 'cardiuma-SemiBold',
                            margin: "0 0 0 4%"
                        }}
                    />

                    <Tab
                        value={2} onClick={() => handleTabChange(2)} className={classes.pending_heading}
                        label={`Sign Up - (${visitorsList.filter(ele => ele.page_name === 'signup').length})`}
                        sx={{
                            borderBottom: tabId !== 2 ? '2px solid #131E2E' : '2px solid #F3D45E',
                            fontFamily: tabId !== 2 ? 'cardiuma-regular' : 'cardiuma-SemiBold',
                            margin: "0 0 0 4%"
                        }}
                    />
                </Tabs>
            </Grid>

            {tabId == 0 && <SocialAd
                campaignList={campaignList}
                campaignInfo={campaignInfo}
                visitorsInfo={visitorsInfo}
            />}

            {tabId == 1 && <BullForce
                visitorsInfo={visitorsInfo}
            />}

            {tabId == 2 && <SignUp
                visitorsInfo={visitorsInfo}
            />}
        </Grid>
    )
}

export default withStyles(styles)(Campaign)